import { Grid } from '@mui/material';
import React, { useContext, useState } from 'react';
import { CompanyContext } from '../../../../context/CompanyContext';
import { classes, TestIdIdentifier } from '../../../../util/identifiers/identifiers.util';
import { Colors } from '../../../util/color.util';

export interface MenuItemTemplateProps {
  testId?: TestIdIdentifier;
  key?: string;
}

export interface MenuItemProps extends MenuItemTemplateProps {
  text: string;
  icon?: JSX.Element;
  onClick: () => void;
}

export default function MenuItem({ text, icon, onClick, testId }: MenuItemProps) {
  const { currentCompany } = useContext(CompanyContext);

  const [hovered, setHovered] = useState(false);

  return (
    <Grid
      item
      xs={12}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: hovered ? Colors.companyLightBackground(currentCompany) : '',
        paddingTop: '0.25rem',
        color: hovered ? Colors.companyDarkText(currentCompany) : '',
      }}
      onClick={event => {
        event.stopPropagation();
        onClick();
      }}
      data-testid={testId}
      className={`pointer h-[32px]  content-center rounded-3 px-2 py-1 text-[14px] text-gray-500 ${classes.menuItem.name}`}
    >
      <Grid container className='select-none'>
        {icon}
        <Grid item flexGrow={1} className={icon ? 'pl-2' : ''} alignContent={'center'}>
          <p>{text}</p>
        </Grid>
      </Grid>
    </Grid>
  );
}
